/*
 * Proprietary and confidential | 2026 | SoundTalks NV
 */

import { fromJS } from 'immutable';
import * as constants from 'data/constants/admin/alert-explain';
import LoadingProgress from 'data/utils/reducers/loading';

export const overviewLoadingProgress = new LoadingProgress('adminAlertExplainOverview');
export const heatmapLoadingProgress = new LoadingProgress('adminAlertExplainHeatmap');
export const alertsLoadingProgress = new LoadingProgress('adminAlertExplainAlerts');
export const rulesLoadingProgress = new LoadingProgress('adminAlertExplainRules');

const loadPane = (key: string, progress: LoadingProgress) => (state: any, action: any) =>
  state.withMutations((newState: any) => {
    newState.set(key, fromJS(action.payload));
    progress.setLoaded(newState);
  });

const clear = (state: any) =>
  state.withMutations((newState: any) => {
    newState.delete('overview');
    newState.delete('heatmap');
    newState.delete('alerts');
    newState.delete('rules');
    overviewLoadingProgress.clear(newState);
    heatmapLoadingProgress.clear(newState);
    alertsLoadingProgress.clear(newState);
    rulesLoadingProgress.clear(newState);
  });

const clearDrilldown = (state: any) =>
  state.withMutations((newState: any) => {
    newState.delete('heatmap');
    newState.delete('alerts');
    heatmapLoadingProgress.clear(newState);
    alertsLoadingProgress.clear(newState);
  });

const initialState = fromJS({});

export default (state = initialState, action: any) => {
  switch (action.type) {
    case constants.OVERVIEW_LOAD_START:
      return overviewLoadingProgress.setLoading(state);
    case constants.OVERVIEW_LOAD_FAILED:
      return overviewLoadingProgress.setLoadFailed(state);
    case constants.OVERVIEW_LOAD_SUCCESS:
      return loadPane('overview', overviewLoadingProgress)(state, action);

    case constants.HEATMAP_LOAD_START:
      return heatmapLoadingProgress.setLoading(state);
    case constants.HEATMAP_LOAD_FAILED:
      return heatmapLoadingProgress.setLoadFailed(state);
    case constants.HEATMAP_LOAD_SUCCESS:
      return loadPane('heatmap', heatmapLoadingProgress)(state, action);

    case constants.ALERTS_LOAD_START:
      return alertsLoadingProgress.setLoading(state);
    case constants.ALERTS_LOAD_FAILED:
      return alertsLoadingProgress.setLoadFailed(state);
    case constants.ALERTS_LOAD_SUCCESS:
      return loadPane('alerts', alertsLoadingProgress)(state, action);

    case constants.RULES_LOAD_START:
      return rulesLoadingProgress.setLoading(state);
    case constants.RULES_LOAD_FAILED:
      return rulesLoadingProgress.setLoadFailed(state);
    case constants.RULES_LOAD_SUCCESS:
      return loadPane('rules', rulesLoadingProgress)(state, action);

    case constants.CLEAR:
      return clear(state);
    case constants.CLEAR_DRILLDOWN:
      return clearDrilldown(state);
    default:
      return state;
  }
};
